import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mb-10 flex flex-wrap justify-center" }
const _hoisted_2 = { class: "flex items-stretch" }
const _hoisted_3 = { class: "m-2 flex flex-col" }
const _hoisted_4 = {
  key: 0,
  class: "locked flex-col justify-center items-center align-center"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "mt-10" }, "STAKED", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "mt-10" }, "NFTs Locked for ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NFTGrid = _resolveComponent("NFTGrid")!
  const _component_ArrowButton = _resolveComponent("ArrowButton")!
  const _component_vue_countdown = _resolveComponent("vue-countdown")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_NFTGrid, {
        title: "Your wallet",
        class: "flex-1 huVjiU",
        nfts: _ctx.desiredWalletNFTs,
        onSelected: _ctx.handleWalletSelected
      }, null, 8, ["nfts", "onSelected"]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_ArrowButton, {
          disabled: _ctx.vaultLocked,
          class: "my-2",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.moveNFTsFE(false)))
        }, null, 8, ["disabled"]),
        _createVNode(_component_ArrowButton, {
          disabled: _ctx.vaultLocked,
          class: "my-2",
          left: true,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.moveNFTsFE(true)))
        }, null, 8, ["disabled"])
      ]),
      (_ctx.bank && _ctx.vault)
        ? (_openBlock(), _createBlock(_component_NFTGrid, {
            key: 0,
            title: "Staking Wallet",
            class: "flex-1 huVjiU",
            nfts: _ctx.desiredVaultNFTs,
            onSelected: _ctx.handleVaultSelected
          }, {
            default: _withCtx(() => [
              (_ctx.vaultLocked)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _hoisted_5,
                    _hoisted_6,
                    _createVNode(_component_vue_countdown, {
                      time: Math.floor(_ctx.farmerAcc.minStakingEndsTs - Date.now()/1000) *1000
                    }, {
                      default: _withCtx(({ days, hours, minutes, seconds }) => [
                        _createTextVNode(_toDisplayString((seconds > 0) ? "Time Remaining：" : "") + _toDisplayString((days > 0) ? days + " d ," : "") + " " + _toDisplayString((hours > 0) ? hours + " h ," : "") + " " + _toDisplayString((minutes > 0) ? minutes + " m ," : "") + " " + _toDisplayString((seconds > 0) ? seconds + " s" : ""), 1)
                      ]),
                      _: 1
                    }, 8, ["time"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["nfts", "onSelected"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}